import { alpha } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';

export function arcadeTokens(theme: Theme) {
    const { primary, secondary, warning, error, grey, common } = theme.palette;
    const screen = primary.darker ?? primary.dark;
    return {
        ink: grey[900], screen, bezel: grey[800],
        violet: primary.light, trim: primary.main, cyan: secondary.light,
        paper: primary.lighter ?? primary.contrastText, gold: warning.light, red: error.light,
        blue: theme.palette.info.light, skin: warning.lighter ?? warning.light, hair: grey[800],
        darkGold: warning.dark, darkRed: error.dark, darkBlue: theme.palette.info.dark,
        white: common.white, muted: primary.lighter ?? primary.contrastText,
        venue: alpha(primary.light, 0.16), venueAccent: alpha(secondary.light, 0.14),
        overlay: alpha(screen, 0.94), scanline: alpha(common.black, 0.04),
        flash: alpha(error.light, 0.12), glass: alpha(common.white, 0.025),
        border: theme.spacing(0.5), fineBorder: theme.spacing(0.25), radius: 0,
        pixel: theme.spacing(0.25), sprite: theme.spacing(4), trophy: theme.spacing(6),
        maxWidth: theme.breakpoints.values.sm, idleHeight: theme.spacing(32),
        boardHeight: theme.spacing(48), buttonHeight: theme.spacing(7),
        glow: theme.shadows[1],
        screenShadow: `inset 0 0 ${theme.spacing(5)} ${alpha(common.black, 0.35)}`,
        burstDistance: theme.spacing(5), victoryDistance: theme.spacing(15), venueBannerOpacity: 0.3,
        fontPixel: { small: 2, label: 2, number: 2.5, title: 4, brand: 2.5 },
        motion: { idle: '2400ms', walk: '240ms', blink: '1800ms', burst: '700ms', penalty: '250ms', victory: '2200ms', count: 700 },
    };
}